import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';

import MedflowLogoFooter from '@/assets/logos/medflow-logo-footer.png';

import colors from '@/design/colors';

const styles = StyleSheet.create({
  container: {
    // Position
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,

    textAlign: 'left',
    paddingHorizontal: 36,
    rowGap: 8,
    flexDirection: 'column',

    // Font
    fontSize: 7,
    color: colors.blackAlpha200,
  },
  logo: {
    width: 82,
    height: 18,
  },
});

const DocumentFooter: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <View style={styles.container} fixed>
      {React.isValidElement(children) ? children : <Text>{children}</Text>}
      <Image style={styles.logo} src={MedflowLogoFooter} />
    </View>
  );
};

export const LegalFooterContent: React.FC = () => (
  <Text>
    Serviço realizado em conformidade com a Lei Nº 13.021/2014 e RDC ANVISA
    44/2009. Este procedimento não tem finalidade de diagnóstico e não substitui
    a consulta médica ou a realização de exames laboratoriais. Seus dados
    pessoais são tratados em conformidade com a Lei Nº 13.709/2018, podendo este
    documento ser armazenado pelo tempo necessário para cumprimento das normas
    aplicáveis.
  </Text>
);

export default DocumentFooter;
